import FrenchPage from '../components/lifecycle/FrenchPage';
import HomeContent from '../components/home/HomeContent';
import HomeHeadFR from "../components/home/HomeHeadFR";

export default function HomeFR() {
  return (
    <>
      <HomeHeadFR />
      <FrenchPage />
      <HomeContent />
    </>
  );
}